module.exports = __webpack_public_path__ + "static/media/dash-1.d67837d6.svg";